import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, Container, Navbar, Nav, InputGroup, Alert} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactMarkdown from 'react-markdown';
import RenderizarProduto from '../Utils/RenderizarProduto';
import RenderizarFoto from '../Utils/RenderizarFoto';
import ImageCropper from '../Utils/ImageCropper';
import BotaoRodape from './BotaoRodape';
import AOS from "aos";
import 'aos/dist/aos.css';


const SelecionarProduto = ({crud, Toast, empresa, storage, queryParams}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [produto, setProduto] = useState(null);
    const [observacoes, setObservacoes] = useState("");
    const id = queryParams.get('id')?.toLowerCase();
    const { get } = crud;
    
    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false
      });
    }, []);
    
    useEffect(()=>{
      const buscarProduto = async()=>{
        try{
          const response = await get(`/gvendas/produtos/${id}/?expand=categoria`, 'produto', false);
          if(response && response.length){
            setProduto(response[0]);
          }
        }catch(err){
          
        }
      }
      if(id){
        buscarProduto();
      }
    },[id]);
    
    const carrinho = () => {
      if (location.key !== 'default') {
        navigate(-1);
      } else {
        navigate(`?`);
      }
    }
    
    const botao = {
      onClick:carrinho, 
      text:'Prosseguir'
    }
    
    
    return (
      <>
        <BotaoRodape produto={produto} empresa={empresa} observacoes={observacoes} setObservacoes={setObservacoes} botao={botao} storage={storage}/>
        <div data-aos="fade-up" className="pb-5 mb-5">
          <ImageCropper so_exibe={true} foto={produto?.foto_do_produto} radius={2} className="col-8 col-md-6 mx-auto text-center"/>
          <Row>
            <Col xs={12} className="fs-4 text-center">
              {produto?.nome_do_produto}
            </Col>
            <Col xs={12} className="fs-4">
              {parseFloat(produto?.preco_unitario||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </Col>
            <Col xs={12} className="">
              {produto?.categoria?.nome_da_categoria||``}
              <ReactMarkdown>{produto?.descricao}</ReactMarkdown>
            </Col>
          </Row>
          <Form.Control 
            as="textarea" 
            placeholder="Alguma observação"
            value={observacoes} 
            onChange={(e) => setObservacoes(e.target.value)} 
            rows={3} 
          />
        </div>
      </>
    );
};

export default SelecionarProduto